<template>
    <div id="noticeList" @scroll="handleScroll">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers title="家校沟通"></headers>
            <div class="notice_btn" @click="actionsheetVisibe=true">发通知</div>
            <div class="notice_list" v-if="notice_list.length>0">
                <div class="list_item" v-for="(no,index) in notice_list" :key="index" @click="toDetail(no)">
                    <div class="item_content">
                        <div class="content_top">
                            <div class="notice_title">{{ no.title }}</div>
                            <div class="notice_time">{{ no.add_time }}</div>
                        </div>
                        <div class="notice_content" v-html="no.content"></div>
                    </div>
                    <div class="item_bottom">
                        <div class="notice_type">{{ no.type }}</div>
                        <div class="notice_status"><img v-if="showEye(no)" class="eye_icon" src="./img/eye.png" alt="">{{ getStatus(no) }}</div>
                    </div>
                </div>
                <div class="no_more" v-if="noMore"><span>没有更多了</span></div>
                <moreLoading v-else></moreLoading>
            </div>
            <noResouse v-else></noResouse>
        </template>
        <transition name="fade">
            <div class="tea_cover" @click="actionsheetVisibe=false" v-show="actionsheetVisibe"></div>
        </transition>
        <transition name="slide">
            <div class="slide_panel" v-show="actionsheetVisibe">
                <div class="sheet_list">
                    <div class="sheet_item" @click="goPub(type.type)" v-for="type in typeList" :key="type.type">{{ type.name }}
                        <div class="item_tips" v-if="type.type==4">(手机端不支持，请登录电脑端发布)</div>
                    </div>
                </div>
                <button class="calcel_btn" @click="actionsheetVisibe=false">取消</button>
            </div>
        </transition>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import headers from 'COMPONENTS/base/header.vue'
    import moreLoading from 'COMPONENTS/moreLoading.vue'
    import noResouse from 'COMPONENTS/noResouse.vue'
    export default {
        components: {
            loadings,headers,moreLoading,noResouse
        },
        data() {
            return {
                loading:true,
                notice_list:[],
                page:1,
                typeList:[
                    {type:5,name:"应用提醒"},
                    {type:1,name:"作业通知"},
                    {type:2,name:"班级通知"},
                    {type:3,name:"节日通知"},
                    {type:4,name:"考试成绩"}
                ],
                noMore:false,
                fetching:false,
                actionsheetVisibe:false
            }
        },
        created() {
            localStorage.removeItem('notice_method');
            localStorage.removeItem('stuList');
            localStorage.removeItem('reminderUnits');
            localStorage.removeItem('is_schedule');
            localStorage.removeItem('defaultTime');
            localStorage.removeItem('defaultTimeStr');
            localStorage.removeItem('radio_type')
            this.getData();
            let info = localStorage.getItem("info");
            if(info){
                let units = JSON.parse(info).units;
                for(let i = 0; i < units.length; i++){
                    if(units[i].sid == 11){
                        this.typeList.unshift({type:0,name:"书法训练营短信提醒"});
                        break;
                    }
                }
            }
        },
        methods: {
            getData(){
                this.fetching = true;
                this.$http.post(API_URL_JXGT_API + '/message/list',{
                    page:this.page,
                    user_type:3
                }).then(res => {
                    res = res.data;
                    if(this.page == 1) this.loading = false;
                    if (res.response == 'ok') {
                        if(res.data.length < 10) this.noMore = true
                        this.notice_list = this.notice_list.concat(res.data);
                    } else {
                        layer.tips(res.message);
                    }
                }).finally(()=>{this.fetching = false});
            },
            getStatus(data){
                if(data.status == 4 && data.method == 2){
                    return "已发送"
                }else if(data.status == 1 && data.is_schedule == 1){
                    return "未发送"
                }else if(data.status == 3 && data.is_schedule == 1){
                    return "已撤销"
                }else{
                    return data.read
                }
            },
            showEye(data){
                if(data.status == 4 && data.method == 2){
                    return false
                }else if(data.status == 1 && data.is_schedule == 1){
                    return false
                }else if(data.status == 3 && data.is_schedule == 1){
                    return false
                }else{
                    return true
                }
            },
            goPub(type){
                if(type!=4){
                    let url = !type ? "/communication/sfsms" : type == 3 ? "/reminder/festivalmodel" : "/reminder/send?type="+type;
                    this.$router.push(url);
                    this.actionsheetVisibe = false;
                }
            },
            //查看通知详情
            toDetail (item) {
                this.$router.push(`/reminder/detail/${item.unit_id}/${item.id}`)
            },
            handleScroll(){
                if(this.noMore || this.fetching) return
                let scrollEle = document.getElementById("noticeList");
                let ch = scrollEle.clientHeight;
                let st = scrollEle.scrollTop;
                let sh = scrollEle.scrollHeight;
                if(sh - st - ch < 50){
                    this.page++;
                    this.getData();
                }
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #noticeList{
        height: 100vh;
        overflow-y: auto;
        .notice_btn{
            position: fixed;
            top: 0;
            right: 32px/$ppr;
            font-size: 30px/$ppr;
            line-height: 96px/$ppr;
            color: #fff;
            z-index: 10;
            opacity: 0.8;
        }
        .notice_list{
            padding: 24px/$ppr;
            .list_item{
                background-color: #fff;
                margin-bottom: 24px/$ppr;
                border-radius: 24px/$ppr;
                padding: 0 24px/$ppr;
                .item_content{
                    padding-top: 40px/$ppr;
                    .content_top{
                        display: flex;
                        justify-content: space-between;
                        height: 50px/$ppr;
                        line-height: 50px/$ppr;
                        .notice_title{
                            font-size: 34px/$ppr;
                        }
                        .notice_time{
                            font-size: 24px/$ppr;
                            color: #999;
                        }
                    }
                    .notice_content{
                        padding: 28px/$ppr 0;
                        line-height: 52px/$ppr;
                        font-size: 30px/$ppr;
                        white-space: pre-wrap;
                    }
                }
                .item_bottom{
                    border-top: 1px/$ppr solid #f1f1f1;
                    height: 102px/$ppr;
                    font-size: 24px/$ppr;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #999;
                    .eye_icon{
                        vertical-align: middle;
                        width: 40px/$ppr;
                        margin-right: 14px/$ppr;
                        margin-top: -6px/$ppr;
                    }
                }
            }
            .no_more{
                width: 100%;
                height: 60px/$ppr;
                line-height: 60px/$ppr;
                color: #999;
                font-size: 24px/$ppr;
                text-align: center;
                span{
                    position: relative;
                    &::before,&::after{
                        content: '';
                        display: block;
                        width: 100px/$ppr;
                        border-bottom: 1px/$ppr solid #ccc;
                        position: absolute;
                        top: 50%;
                    }
                    &::before{
                        left: -110px/$ppr;
                    }
                    &::after{
                        right: -110px/$ppr;
                    }
                }
            }
        }
        .slide_panel{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0 24px/$ppr 24px/$ppr;
            box-sizing: border-box;
            z-index: 10001;
            .sheet_list{
                border-radius: 16px/$ppr;
                background-color: #fff;
                margin-bottom: 24px/$ppr;
                .sheet_item{
                    text-align: center;
                    padding: 16px/$ppr 0;
                    font-size: 32px/$ppr;
                    line-height: 64px/$ppr;
                    border-bottom: 1px/$ppr solid #eee;
                    &:last-child{
                        border-bottom: none;
                    }
                    .item_tips{
                        font-size: 26px/$ppr;
                        line-height: 42px/$ppr;
                        color: #999;
                    }
                }
            }
            .calcel_btn{
                border-radius: 16px/$ppr;
                background-color: #fff;
                height: 96px/$ppr;
                text-align: center;
                font-size: 32px/$ppr;
                color: #5e89ef;
                border: none;
                width: 100%;
                display: block;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .slide-enter-active, .slide-leave-active {
        transition: transform .3s;
    }
    .slide-enter, .slide-leave-to {
        transform: translateY(100%);
    }
</style>